export const ContentAreaStyles = {
  p: {
    marginBottom: 'md',
  },
  '.content-area--hero-region &': {
    marginBottom: '0',
  },
};
